document.getElementById('customProductDescToggleButton').addEventListener('click', function() {
    var content = document.getElementById('customProductDescContainer');
    var button = document.getElementById('customProductDescToggleButton');
    var icon = document.getElementById('customProductDescIcon');

    var downArrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" class="bi bi-arrow-down-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/></svg>';
    var upArrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" class="bi bi-arrow-up-circle-fill" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/></svg>';

    if (content.classList.contains('customProductDescCollapse')) {
        // Expanding
        var fullHeight = content.scrollHeight + "px";
        content.style.maxHeight = fullHeight; // Set to full height
        content.classList.remove('customProductDescCollapse');
        content.classList.add('customProductDescExpanded');
        icon.innerHTML = upArrowSVG; // Up arrow SVG
        button.childNodes[2].nodeValue = ' View Less';
    } else {
        // Collapsing
        content.style.maxHeight = '250px'; // Collapse to initial height
        content.classList.remove('customProductDescExpanded');
        content.classList.add('customProductDescCollapse');
        icon.innerHTML = downArrowSVG; // Down arrow SVG
        button.childNodes[2].nodeValue = ' View More';
    }
});
